import styled from 'styled-components';
import { tablet768, desktop1440 } from '@nubank/nuds-web/styles/breakpoints';

import Block from 'components/structure/Block/Block';
import { paddingBuilder, themeSpace } from 'styles/themeUtils';

const TextBlock = styled(Block)`
  ${paddingBuilder.all(3, 1.5, 0, 1.5)}
  margin-bottom: ${themeSpace(2)};

  ${tablet768`
    width: 100%;

    flex-direction: row;

    margin-bottom: 0px;
    ${paddingBuilder.all(6.5, 3.5, 4.5, 3.5)}
  `}

  ${desktop1440`
    ${paddingBuilder.all(8.5, 7, 5, 7)}
  `}
`;

TextBlock.displayName = 'TextBlock';

export default TextBlock;
